<template>
    <div :class="['plan-item-col', isRecommended ? 'recommend' : '', isBasic ? 'isBasic' : '', isRecommended || isBasic ? 'active' : '']" :style="{
        'border-color': `${color}`
    }" ref="container">
        <!-- pc title -->
        <h4 class="pc">
            <span class="title-label" :style="{'background-color': `${color}`}"></span>
            <span>{{ currentPlan.title }}</span>
        </h4>
        <!-- END pc title -->
        <!-- mobile title -->
        <h4 class="mobile" @click="toggle">
            <p class="title-text" :style="{
                color: `${color}`
            }">
                <i class="icon-icon_down-2"></i>
                <span>{{ currentPlan.title }}</span>
            </p>
            <p class="price">
                <span v-if="!free">
                    <span class="currency">{{ $t(`CURRENCY.${currentPlan.currency}`) }}</span> <span class="count">{{ $n( currentPlan.cycle.standard.salePrice ) }}</span> <span class="unit">/ {{ unit }}</span>
                </span>
                <span v-else class="count">
                    {{ $t( 'plan.free' ) }}
                </span>
            </p>
        </h4>
        <!-- END mobile title -->
        <div class="content-wrap">
            <div class="price-content">
                <select-primary :options="deviceQuantityOptions" v-model="currentDeviceQuantity" class="plan-select" v-if="deviceQuantityOptions.length > 1"></select-primary>
                <select-primary :options="cycleFrequencyOptions" v-model="currentPlanProductIndex" class="plan-select"></select-primary>
                <!-- sale price -->
                <p class="short-cycle">
                    <template v-if="!free">
                            <span class="currency">{{ $t(`CURRENCY.${currentPlan.currency}`) }}</span>
                            <span class="price">{{ $n( currentPlan.cycle.standard.salePrice ) }}</span>
                            <span class="cycle">/{{ unit }}</span>
                    </template>
                    <template v-else>
                        <span class="currency">{{ isBasic ? $t( 'homepage.basic_free_des' ) : $t( 'plan.free' ) }}</span>
                    </template>
                </p>
                <!-- END sale price -->
                <!-- regular price -->
                <p :class="['long-cycle', Number( currentPlan.cycle.standard.regularPrice ) > Number( currentPlan.cycle.standard.salePrice ) ? '' : 'lucency']">
                    <span class="currency">{{ $t(`CURRENCY.${currentPlan.currency}`) }}</span>
                    <span class="price">{{ $n( currentPlan.cycle.standard.regularPrice ) }}</span>
                    <span class="cycle">/ {{ unit }}</span>
                </p>
                <!-- END regular price -->
                <!-- <div v-else class="price-free">
                    {{ $t( 'plan.free' ) }}
                </div> -->
            </div>
            <div class="plan-notice-box">
                <p class="plan-discount red">{{ planDiscount }}</p>
                <p class="plan-notice">{{ currentPlan.description }}</p>
            </div>
            <ul class="bottom-content">
                <li>
                    <i class="icon-check"></i>
                    <span class="plan-featrue-number" v-html="$options.filters.planHistory(currentPlan)"></span>
                </li>
                <li>
                    <i class="icon-check"></i>
                    <span v-html="$options.filters.planCamera(currentPlan)"></span>
                </li>
                <li v-if="!FEATURE('dashboard.used_space')">
                    <i class="icon-check"></i>
                    <span v-html="$options.filters.planCapacity(currentPlan)"></span>
                </li>
            </ul>
        </div>
        <span class="top-label" :style="{
            'background-color': `${color}`
        }"></span>
        <span class="recommend-label" v-if="currentPlan.metadata[ 'plan.recommended' ]" :style="{
            'border-color': `${color} transparent transparent transparent`
        }">
            <i class="icon-icon_stra"></i>
        </span>
    </div>
</template>

<script>
import selectPrimary from '@/basic/selectPrimary';
import { orderedProductInfo, freePlanRenewable } from '@/api/plan';
import {subscription as paymentStatus, plan as planStatus} from '@/config/status';
import {config} from 'CONFIG';
import router from '@/router';
import user from '@/api/user';
import { isMobile } from '@/common/js/utils';
import {timeResolvePDT} from '@/common/js/date';

export default {

    components: {

        selectPrimary

    },
    props: {

        plan: Object,
        subscription: {

            default () {

                return null;

            }

        },
        listIndex: Number,
        activeItem: Number

    },
    data () {

        return {

            currentDeviceQuantity: 1,
            currentPlanProductIndex: 0,
            config

        };

    },
    computed: {

        isMobile () {

            return isMobile();

        },

        currentPlan () {

            return this.plan.products[ this.currentPlanProductIndex ];

        },
        isBasic () {

            return this.plan.serialName === config.basic_plan_title;

        },

        isRecommended () {

            return this.currentPlan.metadata[ 'plan.recommended' ];

        },

        deviceQuantityOptions () {

            let arr = this.plan.products.map(( product, index ) => {

                return product.metadata['cloud_storage.max_device_quantity'];

            });

            return [...new Set( arr )].map(( deviceQuantity ) => {

                return {

                    value: deviceQuantity,
                    label: this.$tc( 'maxDeviceQuantity', deviceQuantity, {

                        count: deviceQuantity

                    })

                };

            });

        },
        cycleFrequencyOptions () {

            let arr = [];

            this.plan.products.forEach(( product, index ) => {

                if ( product.metadata['cloud_storage.max_device_quantity'] === this.currentDeviceQuantity ) {

                    arr.push({
                        value: index,
                        label: this.$tc( `cycle.${product.cycle.standard.interval.unit}`, product.cycle.standard.interval.frequency, {

                            count: product.cycle.standard.interval.frequency

                        })
                    });

                }

            });

            return arr;

        },
        space () {

            let space = this.currentPlan.metadata['cloud_storage.space_capacity'];
            return Number( space / ( 1024 * 1024 * 1024 )).toFixed( 2 );

        },
        color () {

            return this.currentPlan.metadata[ 'plan.display_color' ];

        },
        userStatus () {

            return this.$store.state.user.status;

        },
        showButton () {

            return this.userStatus === 'logined' || this.userStatus === 'notLogined';

        },
        unit () {

            let interval = this.currentPlan.cycle.standard.interval;
            return this.$tc( `cycle_unit.${interval.unit}`, interval.frequency, {

                count: interval.frequency

            });

        },
        free () {

            return Number( this.currentPlan.cycle.standard.salePrice ) === 0;

        },
        disabled () {

            let sub = this.subscription;
            let currentPlan = this.currentPlan;
            if ( currentPlan.title === config.beta_plan_title ) {

                /**
                 * beta套餐不允许续费和切换
                 */
                if ( sub ) {

                    return true;

                } else {

                    return false;

                }

            } else if ( currentPlan.status !== planStatus.ENABLED ) {

                return true;

            } else if ( !sub ) {

                return false;

            } else if ( sub.status === paymentStatus.ACTIVATING || sub.status === paymentStatus.DEACTIVATING ) {

                /**
                 * 订阅状态为正在处理时，不可点击
                 */

                return true;

            } else if ( sub.status !== paymentStatus.ACTIVE ) {

                /**
                 * 订阅已失效，开放点击
                 */

                return false;

            } else if ( sub.plan.id === currentPlan.id ) {

                /**
                 * 续费套餐：
                 *
                 * 收费无限制
                 *
                 * 免费需在过期前一个周期内续费
                 */
                return !( !this.free || freePlanRenewable( sub ));

            } else {

                /**
                 * 切换套餐
                 */

                return new Date().getTime() <= sub.nextSwitchableAt;

            }

        },

        showBeta () {

            return this.$store.state.user.showBeta && this.currentPlan.title !== config.beta_plan_title;

        },

        limitedDay () {

            let limitedDay = this.currentPlan[ 'metadata' ][ 'virtual_product.effect_ttl' ];
            if ( !limitedDay ) {

                return {};

            }
            let date = timeResolvePDT( limitedDay );
            return {

                year: date.year,
                monthAbbr: date.monthAbbr,
                monthlong: date.monthLong,
                dateOfMonthOrder: date.dateOfMonthOrder,
                dateOfMonth: date.dateOfMonth

            };

        },

        planDiscount () {

            let currentPlan = this.currentPlan;
            let { regularPrice, salePrice } = currentPlan.cycle.standard;
            regularPrice = Number( regularPrice );
            salePrice = Number( salePrice );
            if ( salePrice === 0 || !regularPrice || regularPrice === 0 || regularPrice <= salePrice ) {

                return '';

            }
            let discount = Math.floor( 100 - ( salePrice * 100 / regularPrice ));
            return discount === 0 ? '' : this.$t( 'plan.discount', { discount });

        }

    },
    methods: {

        async subscribe () {

            let id = this.currentPlan.id;
            if ( this.userStatus === 'logined' ) {

                try {

                    let sub = await orderedProductInfo();
                    let path = ( sub && sub.status === paymentStatus.ACTIVE && sub.plan.title !== config.beta_plan_title ) ? '/user/update-plan/' : '/user/subscribe-plan/';
                    router.push({

                        path,
                        query: {

                            plan_id: id

                        }

                    });

                } catch ( err ) {

                    console.log( err );

                }

            } else {

                user.goToAccountCenter( true );

            }

        },
        toggle () {

            let container = $( this.$refs.container );
            container.toggleClass( 'active' );
            container.find( '.content-wrap' ).slideToggle( 500 );
            if ( container.hasClass( 'active' )) {

                this.$emit( 'changeActive', this.listIndex );

            }

        }

    },
    watch: {

        activeItem ( activeItem ) {

            if ( activeItem !== this.listIndex ) {

                let container = $( this.$refs.container );
                container.removeClass( 'active' );
                container.find( '.content-wrap' ).slideUp( 500 );

            }

        },
        deviceQuantityOptions: {

            handler ( n ) {

                this.currentDeviceQuantity = n[0].value;

            },
            immediate: true

        },
        cycleFrequencyOptions: {

            handler ( n ) {

                this.currentPlanProductIndex = n[0].value;

            },
            immediate: true

        }

    }

};
</script>

<style lang="less">
.plan-item-col .bottom-content li>span>span{
    font-weight: 500;
}
.plan-featrue-number span{
    font-weight: 500;
}
</style>

<style scoped lang="less">
.plan-item-col{
    border-radius: 0.2rem;
    background-color: #fff;
    display: inline-block;
    padding: 0.6rem 0.28rem 0.4rem;
    text-align: center;
    position: relative;
    transition: padding 0.5s;
    overflow: hidden;
    width: 285px;
    &.recommend{
        border: 1px solid;
        padding-bottom: 0.6rem;
        width: 300px;
    }
    @media @mobile{
        &.active{
            background-color: #f3f4f9;
        }
        &, &.recommend{
            border-radius: 0;
            border: none;
            padding: 0;
            display: block;
        }
    }
}
.plan-item-col.active h4.mobile .title-text i{
    transform: rotate(0deg);
}
h4 {
    font-weight: 700;
    &.mobile{
        display: none;
    }
    &.pc{
        font-size: 0.24rem;
        margin-bottom: .3rem;
        position: relative;
        top: 0;
        .free-title{
            font-size: 0.16rem;
            font-weight: 400;
            position: absolute;
            left: 50%;
            bottom: -0.25rem;
            width: 100%;
            transform: translateX(-50%);
        }
    }
    span {
        vertical-align: middle;
    }
    @media @mobile {
        &.mobile{
            display: flex;
            padding: 0.6rem 15px;
            justify-content: space-between;
            border-top: 1px solid #eee;
            .title-text{
                font-weight: 700;
                font-size: 0;
                i{
                    font-size: 0.28rem;
                    vertical-align: middle;
                    margin-right: .1rem;
                    display: inline-block;
                    transform: rotate(-90deg);
                    transition: .5s;
                }
                span{
                    font-size: 0.38rem;
                }
            }
            .currency{
                font-weight: 500;
                font-size: 0.34rem;
            }
            .count{
                font-weight: 500;
                font-size: 0.34rem;
            }
            .unit{
                font-size: 0.24rem;
            }
            span.free-title{
                color: #333;
                font-weight: 400;
                font-size: 0.26rem;
            }
        }
        &.pc{
            display: none;
        }
    }
}
.price-content{
    border-top: 1px solid #eee;
    padding: 0.3rem 0 0;
    position: relative;
    top: 0;
    left: 0;
    box-sizing: content-box;
    min-height: 1.37rem;
    @media @mobile{
        padding: 0.6rem 0 0;
        border-top: 1px solid #ccc;
        min-height: auto;
        .subscribe-button{
            margin-bottom: .21rem;
            margin-top: 0.6rem;
        }
    }
}
.plan-notice-box{
    position: relative;
    height: 1.22rem;
    @media @mobile {
        height: auto;
        padding-bottom: 0.3rem;
    }
}
.plan-discount{
    font-size: 0.16rem;
    padding-top: 0.16rem;
    @media @mobile {
        padding-top: 0;
        font-size: 0.28rem;
        margin-bottom: 0.7rem;
    }
}
.plan-notice{
    position: absolute;
    bottom: 0.1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    font-size: .14rem;
    color: #E74330;
    @media @mobile{
        margin: 0 auto;
        position: static;
        transform: none;
        font-size: 0.26rem;
        max-width: 6.9rem;
    }
}
.plan-select{
    & + .plan-select {
        margin-top: 0.14rem;
    }
    @media @mobile{
        background-color: #fff;
        margin-right: 0.3rem;
        &:nth-of-type(2) {
            margin-top: 0;
        }
    }
}
.short-cycle{
    margin-top: .36rem;
    margin-bottom: .1rem;
    @media @mobile{
        margin: 0.4rem auto 0.16rem;
        max-width: 6.9rem;
    }
    .currency{
        font-size: 0.28rem;
        font-weight: 500;
        @media @mobile{
            font-size: 0.5rem;
        }
    }
    .price{
        font-weight: 500;
        font-size: 0.3rem;
        @media @mobile{
            // display: inline-block;
            // &:first-letter{
            //     font-size: 0.61rem;
            // }
            font-size: 0.6rem;
        }
    }
    .cycle{
        font-size: .2rem;
        @media @mobile{
            font-size: 0.32rem;
        }
    }
}
.long-cycle{
    text-decoration: line-through;
    &.lucency{
        opacity: 0;
    }
    @media @mobile{
        margin-bottom: 0.16rem;
        font-size: 0.28rem;
        &.lucency{
            display: none;
        }
    }
    .currency{
        font-size: 0.16rem;
        font-weight: 400;
        @media @mobile{
            font-size: 0.24rem;
        }
    }
    .price{
        font-size: 0.18rem;
        font-weight: 500;
        @media @mobile{
            font-size: 0.28rem;
        }
    }
    .cycle{
        font-size: 0.16rem;
        @media @mobile{
            font-size: 0.24rem;
        }
    }
}
.bottom-content{
    padding-top: 0.16rem;
    border-top: 1px solid #eee;
    text-align: left;
    @media @mobile{
        border-color: #ccc;
        padding: .3rem 0 .6rem;
        display: inline-block;
    }
    i{
        color: @theme;
        font-size: 0.18rem;
        vertical-align: middle;
        margin-right: .05rem;
        @media @mobile{
            font-size: 0.2rem;
            margin-right: 0.2rem;
        }
    }
    span{
        vertical-align: middle;
        font-size: 0.16rem;
        @media @mobile{
            font-size: 0.24rem;
        }
    }
    li+li{
        margin-top: 0.15rem;
        @media @mobile{
            margin-top: 0.2rem;
        }
    }
}
.top-label{
    display: block;
    height: 3px;
    position: absolute;
    top: 0;
    width: calc(100% - 0.3rem);
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    border-radius: 1rem;
    @media @mobile{
        display: none;
    }
}
.recommend-label{
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.8rem 0.8rem 0 0;
    position: absolute;
    left: 0;
    top: 0;
    i{
        color: #fff;
        font-size: 0.25rem;
        position: absolute;
        top: -0.67rem;
        left: 0.1rem;
    }
    @media @mobile{
        display: none;
    }
}
.title-label{
    display: inline-block;
    border-radius: 100%;
    width: 10px;
    height: 10px;
    margin-right: 0.1rem;
    @media @mobile{
        display: none;
    }
}
@media @mobile{
    .plan-item-col:not(.recommend):not(.isBasic) .content-wrap{
        display: none;
    }
}
.price-free{
    font-size: 0.36rem;
    font-weight: 500;
    padding-top: 0.7rem;
    @media @mobile{
        margin-bottom: 0.6rem;
        font-size: 0.76rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/planItemCol.vue